<ng-container *ngIf="language!=LANGUAGE_ENUM.EN">
    <div class="extra-large-screen doc-check-login-page">
        <div class="login-form-section">
            <div class="login-form-container">
                <div class="login-form-header">
                    <a href="/pep">
                        <img src="/pep/PEP Text Logo.svg" alt="Copeia PEP" />
                    </a>
                    <div>
                        <h2>{{headingName}}</h2>
                    </div>

                </div>
                <div class="login-form-content">
                    <div class="doccheck-container">
                        <div class="doccheck_login">
                            <iframe align="left" frameborder="0" scrolling="no" [attr.width]="DocCheckWidth" [attr.height]="DocCheckHeight" name="dc_login_iframe" id="dc_login_iframe" [src]="DocCheckLoginUrl"><a href="javascript:void(0);" [href]="DocCheckLoginUrl" target="_blank">LOGIN</a></iframe>
                        </div>
                    </div>


                    <div class="footer-container">
                        <div class="footer-link">
                            <ul>
                                <li>
                                    <a href="https://copeia.de/datenschutz" target="_blank">Datenschutz</a>
                                </li>
                                <li>
                                    <a href="mailto:info@copeia.de">Kontakt</a>
                                </li>
                            </ul>
                            <div class="text-right"><small>© Copeia GmbH, {{fullYear}}</small></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="language==LANGUAGE_ENUM.EN">
    <div class="doc-check-login-page">
        <div class="loin-form-en-section">
            <app-header></app-header>
            <div class="container-xl">
                <div class="login-form-container">
                    <div class="login-form-left">
                        <div class="heading">PEP EN Login</div>
                        <p>We use DocCheck for access to PEP to ensure that the platform remains compliant with regulatory requirements for handling sensitive medical information.</p>
                        <div class="doccheck-info">
                            <img class="mb-2" src="/pep/images/en/Doc Check Website Icon.svg" alt="" />
                            <div><strong>Don‘t have a DocCheck account?</strong></div>
                            <div>What is it and how to register with DocCheck</div>
                            <div class="more-info">
                                →
                                <a class="blue-color" href="/pep/en/doccheck-info">More Information</a>
                            </div>
                        </div>
                    </div>
                    <div class="login-form-right">
                        <div class="doccheck-container">
                            <div class="doccheck_login">
                                <iframe align="left" frameborder="0" scrolling="no" [attr.width]="DocCheckWidth" [attr.height]="DocCheckHeight" name="dc_login_iframe" id="dc_login_iframe" [src]="DocCheckLoginUrl"><a href="javascript:void(0);" [href]="DocCheckLoginUrl" target="_blank">LOGIN</a></iframe>
                            </div>
                        </div>
                        <div class="doccheck-info">
                            <img class="mb-2" src="/pep/images/en/Doc Check Website Icon.svg" alt="" />
                            <div><strong>Don‘t have a DocCheck account?</strong></div>
                            <div>What is it and how to register with DocCheck</div>
                            <div class="more-info">
                                →
                                <a class="blue-color" href="/pep/en/doccheck-info">More Information</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
